'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const Margin = (props) => React__default.default.createElement("div", { style: { margin: props.margin }, "data-zds": true }, props.children);

exports.Margin = Margin;
//# sourceMappingURL=Margin.cjs.js.map
